import { ColumnDef } from '@tanstack/react-table';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Divider, Text } from 'theme-ui';
import { getAllTaskMappingMasterData } from '../../../../store/actions/masterData.action';
import { IndeterminateCheckbox } from '../../../CheckBox/CheckBox';
import DataTable from '../../../Tabels/Tabel';
import { setPagination } from '../../../../store/actions/Pagination.action';
import TableActions from '../../users/TableActions';
import { TabelHeadingTxt } from '../../../Text/TabelCommonTxt';
import { useNavigate } from 'react-router-dom';
import plus from "../../../assets/images/Icon/plus.svg";

const TaskSowMasterData: React.FC = () => {
    const navigate = useNavigate();
    const [refresh, setRefresh] = useState<boolean>(true);
    const { tasksowMapping, loader } = useSelector((state: any) => state.masterData);
    const { paginations } = useSelector((state: any) => state.pagination);

    const columns = useMemo<ColumnDef<any>[]>(() => [
        // {
        //     accessorKey: "id",
        //     enableColumnFilter: false,
        //     id: "select",
        //     header: ({ table }) => (
        //         <div className="d-flex justify-content-center">
        //             <IndeterminateCheckbox
        //                 {...{
        //                     checked: table.getIsAllRowsSelected(),
        //                     indeterminate: table.getIsSomeRowsSelected(),
        //                     onChange: table.getToggleAllRowsSelectedHandler(),
        //                 }}
        //             />
        //         </div>
        //     ),
        //     cell: ({ row }) => (
        //         <IndeterminateCheckbox
        //             {...{
        //                 checked: row.getIsSelected(),
        //                 disabled: !row.getCanSelect(),
        //                 indeterminate: row.getIsSomeSelected(),
        //                 onChange: row.getToggleSelectedHandler(),
        //             }}
        //         />
        //     ),
        // },
        {
            header: 'No',
            enableColumnFilter: false,
            accessorKey: "no",
            cell: ({ row }) => {
                return (
                    <Text variant='Poppins14Normal24lh'>{((paginations?.currentPage - 1) * paginations?.limit) + row?.index + 1}</Text>
                )
            }
        },
        {
            accessorKey: "taskName",
            header: 'Task Name',
            cell: info => info.getValue(),
        },
        {
            header: "Sop Item",
            accessorKey: "sopItem",
            cell: info => info.getValue(),
        },
        {
            header: 'Default Type',
            enableColumnFilter: false,
            accessorKey: "default",
            cell: ({ row }) => {
                return (
                    <IndeterminateCheckbox
                        {...{
                            checked: row?.original?.default,
                            //indeterminate: table.getIsSomeRowsSelected(),
                            //onChange: table.getToggleAllRowsSelectedHandler(),
                        }}
                    />
                )
            },
        },
        {
            header: 'Accessor',
            accessorKey: "Accessor",
            enableColumnFilter: false,
            cell: ({ row }) => {
                return (
                    <TableActions row={row} editTo={`/edit-task-sow/${row?.original?._id}`} deleteMessage='Are you sure you want to delete this task sow?' deleteApi={`task-sow/delete-task-sow/${row?.original?._id}`} toggleRefresh={() => setRefresh(true)} />
                )
            },
        }
    ], [tasksowMapping?.data]);

    useEffect(() => {
        return () => {
            dispatch(setPagination({
                limit: 15,
                currentPage: 1,
            }))
        }
    }, [])
    const dispatch = useDispatch()
    useEffect(() => {
        if (refresh) {
            dispatch(getAllTaskMappingMasterData(paginations))
            setRefresh(false)
        }
    }, [refresh])
    const handleclick = () => {
        navigate("/create-task-sow")
    }
    return (
        <div className='main-content'>
            <TabelHeadingTxt Title='Task Sow' Count={tasksowMapping?.count || 15} BtnTxt='Create Task Sow' src={plus} onClick={handleclick} sx={{ backgroundColor: '#7743DB', color: 'white' }} />
            <Divider sx={{ color: '#D9D7DD' }} opacity={2} my={[3, 3, 4]} />
            <DataTable
                loader={loader}
                columns={columns}
                data={tasksowMapping?.data || []}
                TotalLength={tasksowMapping?.count || null}
                perPageCount={paginations.limit}
                currentPage={paginations.currentPage}
                onPerPageChange={(itemsPerPage) => {
                    dispatch(setPagination({
                        limit: itemsPerPage,
                        currentPage: 1
                    }));
                    setRefresh(true);
                }}
                onPageChange={(value) => {
                    dispatch(setPagination({
                        ...paginations,
                        ...{ currentPage: value }
                    }));
                    setRefresh(true);
                }} />

        </div>
    )
};

export default TaskSowMasterData;
